import { Component, OnInit, Output,EventEmitter } from '@angular/core';
import { Reservation } from '@app/models/micro/reservation.model';
import { GlobalsService } from '@app/services/micro/globals.service';
import { PAX_TYPE } from "@app/enums";
/**
  Componente que permite aplicar una acción a todos los pasajeros de una reserva, excluyendo a los infantes.
  Este componente muestra un interruptor (toggle) que, al activarse, emite un evento para indicar que la acción
  debe aplicarse a todos los pasajeros. También verifica si hay más de un pasajero no infante para habilitar
  la funcionalidad de "aplicar a todos".
**/
@Component({
    selector: 'app-apply-all-passengers',
    templateUrl: './apply-all-passengers.component.html',
    styleUrls: ['./apply-all-passengers.component.scss'],
    standalone: false
})
export class ApplyAllPassengersComponent implements OnInit {
   /**
    Evento que se emite cuando el interruptor (toggle) cambia de estado.
    @type {EventEmitter<boolean>}
  **/
    @Output() isOnProp: EventEmitter<boolean> = new EventEmitter<boolean>();

    /**
      Estado actual del interruptor (toggle).
      @type {boolean}
      @default false
    **/
    isOn: boolean = false;
  
    /**
      Indica si se debe mostrar la opción de "aplicar a todos".
      @type {boolean}
    **/
    showApplyAll: boolean = false;
  
    /**
      Información de la reserva actual.
      @type {Reservation}
    **/
    reservation: Reservation;

  constructor(
    private global: GlobalsService
  ) { }

  ngOnInit(): void {
    this.reservation = this.global.getReservation();
    this.showApplyAll = this.countPassengerNoInfant(this.reservation.passengers) > 1
  }
    /**
    Cambia el estado del interruptor (toggle) y emite el evento `isOnProp` con el nuevo estado.
    @return void
  **/
  toggle(){
    this.isOn = !this.isOn;
    this.isOnProp.emit(this.isOn)
}
 /**
    Cuenta el número de pasajeros que no son infantes en la lista de pasajeros.
    @param {Array} passengers - Lista de pasajeros.
    @return {number} Número de pasajeros no infantes.
  **/
  countPassengerNoInfant(passengers){
    let nonInfantCount = 0;

    for (const passenger of passengers) {
      if (passenger.paxType !== PAX_TYPE.INFANT) {
        nonInfantCount++;
      }
    }

    return nonInfantCount
  }
}
